import { ParsedNumber } from '../parsed/parsedNumber';
import { z } from 'zod';

export const Coordinate = z.object({
    x: z.preprocess((x) => x ?? undefined, ParsedNumber.default(0)),
    y: z.preprocess((x) => x ?? undefined, ParsedNumber.default(0)),
    systemId: z.number().nullish(),
});
export type Coordinate = z.infer<typeof Coordinate>;
